import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useState } from "react";
import { ClickOutsideComponent } from "shared/components/CommentsController/components/ClickOutside";
import { tooptipStylesWhite } from "shared/constants/tooptipStyles";
import styled from "styled-components";

export const TooltipWrapper = styled(FlexBox)<{ tooltipOpen?: boolean }>`
    > div {
    justify-content: flex-start;
    cursor: pointer;
    color: #909090;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    }
    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
       > div {
        font-size: 13px;
        line-height: 16px; 
       }
    }
    @media(max-width: ${LayoutConst.screen.l}px){
       > div {
        font-size: 11px;
        line-height: 13px;
      } 
    }   
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      div[opacity="1"] {
        display: ${({ tooltipOpen }) => tooltipOpen ? 'flex' : 'none'};
        left: -20px;
        padding: 2px 8px 4px 8px;
        font-size: 11px;
        line-height: 13px;
      }
    }   
`

interface Iprops {
    visible: boolean,
    text: any,
    placeholder: string
}

export const HintInfo: FC<Iprops> = ({ visible, text, placeholder }) => {
  const isS = useBreakpoint(LayoutConst.screen.s - 1 );
  const [open, setOpen] = useState(false);

  const handleChange = (ev: React.SyntheticEvent) => {
    ev.preventDefault()
    ev.stopPropagation();
    setOpen(!open)
  }

  const onClose = (ev: React.SyntheticEvent) => {
    ev.preventDefault();
    ev.stopPropagation();
    setOpen(false)
  }

  if (!visible) return null

    if (isS) {
        return (
          <ClickOutsideComponent onClose={onClose}>
            <TooltipWrapper onClick={handleChange} tooltipOpen={open}>
              <HintTooltip 
                customStyle={tooptipStylesWhite}
                isPermanent={true} 
                noArrow 
                activeOnMobile 
                positionY="bottom" 
                text={text}
                z={6} 
                onWhiteBg
              >
                <div>{placeholder}</div>
              </HintTooltip>
            </TooltipWrapper>
          </ClickOutsideComponent>
        )
    }
    return (
      <TooltipWrapper>
        <HintTooltip positionY="top" text={text} z={6} noDisappearDelay onWhiteBg customStyle={tooptipStylesWhite}>
          <div>{placeholder}</div>
        </HintTooltip>
      </TooltipWrapper>
    )
}import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useState } from "react";
import { ClickOutsideComponent } from "shared/components/CommentsController/components/ClickOutside";
import { tooptipStylesWhite } from "shared/constants/tooptipStyles";
import styled from "styled-components";

export const TooltipWrapper = styled(FlexBox)<{ tooltipOpen?: boolean }>`
    > div {
    justify-content: flex-start;
    cursor: pointer;
    color: #909090;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;
    }
    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
       > div {
        font-size: 13px;
        line-height: 16px; 
       }
    }
    @media(max-width: ${LayoutConst.screen.l}px){
       > div {
        font-size: 11px;
        line-height: 13px;
      } 
    }   
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      div[opacity="1"] {
        display: ${({ tooltipOpen }) => tooltipOpen ? 'flex' : 'none'};
        left: -20px;
        padding: 2px 8px 4px 8px;
        font-size: 11px;
        line-height: 13px;
      }
    }   
`

interface Iprops {
    visible: boolean,
    text: any,
    placeholder: string
}

export const HintInfo: FC<Iprops> = ({ visible, text, placeholder }) => {
  const isS = useBreakpoint(LayoutConst.screen.s - 1 );
  const [open, setOpen] = useState(false);

  const handleChange = (ev: React.SyntheticEvent) => {
    ev.preventDefault()
    ev.stopPropagation();
    setOpen(!open)
  }

  const onClose = (ev: React.SyntheticEvent) => {
    ev.preventDefault();
    ev.stopPropagation();
    setOpen(false)
  }

  if (!visible) return null

    if (isS) {
        return (
          <ClickOutsideComponent onClose={onClose}>
            <TooltipWrapper onClick={handleChange} tooltipOpen={open}>
              <HintTooltip 
                customStyle={tooptipStylesWhite}
                isPermanent={true} 
                noArrow 
                activeOnMobile 
                positionY="bottom" 
                text={text}
                z={6} 
                onWhiteBg
              >
                <div>{placeholder}</div>
              </HintTooltip>
            </TooltipWrapper>
          </ClickOutsideComponent>
        )
    }
    return (
      <TooltipWrapper>
        <HintTooltip positionY="top" text={text} z={6} noDisappearDelay onWhiteBg customStyle={tooptipStylesWhite}>
          <div>{placeholder}</div>
        </HintTooltip>
      </TooltipWrapper>
    )
}